import { api } from "./api";
import { AxiosError, AxiosResponse } from 'axios';
import { AuthBodyType } from "./types";

export type newNotificationType = {
  id?: string;
  name: string;
  message: string;
  serviceType: string;
  company: string;
  creationDate?: number;
};

export default class NovaNotificacao {


  getAll = async (token: AuthBodyType) => {
    try {
      const data: AxiosResponse = await api.post("/newNotification/getAll", {
        ...token,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  create = async (token: AuthBodyType, notification: newNotificationType) => {
    try {
      const data: AxiosResponse = await api.post("/newNotification/create", {
        ...token,
        notification,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  edit = async (token: AuthBodyType, notification: newNotificationType) => {
    try {
      const data: AxiosResponse = await api.post("/newNotification/edit", {
        ...token,
        notification,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  delete = async (token: AuthBodyType, notificationId: string) => {
    try {
      const data: AxiosResponse = await api.post("/newNotification/delete", {
        ...token,
        notificationId,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  getAllByTypes = async (token: AuthBodyType) => {
    try {
      const data: AxiosResponse = await api.post("/newNotification/getAllByTypes", {
        ...token
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };
}
